import React, { Component } from "react";
import { Control, Fieldset, Form/*, Errors*/ } from "react-redux-form";
import moment from "moment";
import { formatMoney } from "accounting-js";
import _ from "lodash";
import RevisionComment from "../../elements/revision/widget/project_revision_select";
import NotificationStatus from "../forms/notification_status";
import EditStatus from "../forms/edit_status";
import TextEditor from "../forms/wysiwyg_field";
import ScrollToTopOnMount from './../scroll_top';
import { toInt } from "../parsers";
import ActorsReviewModal from "./widget/actors_modal";
import ConagoReviewModal from "./widget/conago_modal";
import RowQuestion from "./widget/row_widget";

export default class ProjectRevisionForm extends Component {
	render() {
		const { resource_concepts, revision, project, directories } = this.props;
		const { conclusion, registry, expenses, profiles, instance } = project;
		const { modality } = this.props.match.params;
		let expensesTotal = 0;
		let employeesAgency = !_.isEmpty(profiles.data.agency) ? profiles.data.agency.employees : [];
		let employeesProject = !_.isEmpty(profiles.data.employees) ? profiles.data.employees : [];
		return (
			<div>
				<ScrollToTopOnMount />

				<div className="columns is-centered">
					<div className={`column is-${revision.surveyShow ? '7' : '10'}`}>
						<ConagoReviewModal
							closeModal={this._toggleConagoModal}
							active={this.state.conagoShow}
							conago={this.state.goalConago}
						/>
						<ActorsReviewModal
							closeModal={this._toggleActorsModal}
							active={this.state.actorsShow}
							actors={this.state.goalActors}
							fetching={directories.actors.isFetching}
						/>
						<Form model="revision" onSubmit={(values => this._handleSubmit(values))} onSubmitFailed={(error) => {
							console.log('error: ', error);
							this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')
						}}>

							{!_.isEmpty(revision.phase_group) && <h3 className="title is-3" dangerouslySetInnerHTML={{ __html: `Revisión - ${revision.phase_group.name}` }}></h3>}

							<h5 className="title is-5">{modality === 'modalidad-i' ? 'Modalidad I' : (modality === 'modalidad-ii' ? 'Modalidad II' : 'Modalidad III')}</h5>

							<Fieldset model=".registry.body" component="fieldset" className="fieldset">
								<legend>Datos del proyecto</legend>
								{registry && !_.isEmpty(registry.data) && registry.data.name ?
									<table className="is-fullwidth table">
										<tbody>
											<tr>
												<td>
													<span className="help is-dark">Instancia</span>
													<strong>{instance.data.name}</strong>
												</td>
												<td>
													<div className="columns">
														<div className="column is-2">
															<i className="fa fa-calendar" />
														</div>
														<div className="column">
															<span className="help is-dark">Fecha de ejecución inicial</span>
															<strong>{moment(registry.data.execution_start).format('DD/MMMM/YYYY')}</strong>
														</div>
													</div>
												</td>
												<td>
													<div className="columns">
														<div className="column is-2">
															<i className="fa fa-calendar" />
														</div>
														<div className="column">
															<span className="help is-dark">Fecha de ejecución final</span>
															<strong>{moment(registry.data.execution_end).format('DD/MMMM/YYYY')}</strong>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td colSpan={3}>
													<span className="help is-dark">Nombre del proyecto</span>
													<strong>{registry.data.name}</strong>
												</td>
											</tr>
											<tr>
												<td colSpan={3}>
													<p style={{ marginBottom: '10px' }} className="help is-dark">Objetivo</p>
													<div className="content" dangerouslySetInnerHTML={{ __html: registry.data.objective }} />
												</td>
											</tr>
											<tr>
												<td colSpan={3}>
													<p style={{ marginBottom: '10px' }} className="help is-dark">Justificación</p>
													<div className="content" dangerouslySetInnerHTML={{ __html: registry.data.justification }} />
												</td>
											</tr>
											<tr>
												<td colSpan={3}>
													<p style={{ marginBottom: '10px' }} className="help is-dark">Planteamiento del problema</p>
													<div className="content" dangerouslySetInnerHTML={{ __html: registry.data.planteamiento_problema }} />
												</td>
											</tr>
											<tr>
												<td colSpan={3}>
													<p style={{ marginBottom: '10px' }} className="help is-dark">Diagnóstico y problema central</p>
													<div className="content" dangerouslySetInnerHTML={{ __html: registry.data.diagnostico_problema	 }} />
												</td>
											</tr>
											<tr>
												<td colSpan={3}>
													<p style={{ marginBottom: '10px' }} className="help is-dark">Población beneficiada directa. Describir el perfil de la población beneficiada</p>
													<div className="content" dangerouslySetInnerHTML={{ __html: registry.data.poblacion_beneficiada }} />
												</td>
											</tr>
											<tr>
												<td colSpan={3}>
													<p style={{ marginBottom: '10px' }} className="help is-dark">Describir la metodología para la evaluación de los resultados del proyecto</p>
													<div className="content" dangerouslySetInnerHTML={{ __html: registry.data.metodologia }} />
												</td>
											</tr>
											<tr>
												<td colSpan={3}>
													<p style={{ marginBottom: '10px' }} className="help is-dark">Describir cómo se dará a conocer el proyecto y sus resultados a las personas beneficiarias para cualquier persona interesada en conocer sobre el logro de sus objetivos y el uso de los recursos</p>
													<div className="content" dangerouslySetInnerHTML={{ __html: registry.data.descripcion_publicacion }} />
												</td>
											</tr>
											<tr>
												<td colSpan={3}>
													<span className="help is-dark">Revisión del proyecto</span>
													<div className="field has-addons">
														<div className="control">
															<div className="select">
																<Control model=".status" component={NotificationStatus} defaultValue={revision.registry.body && revision.registry.body.status ? revision.registry.body.status : 'success'} />
															</div>
														</div>
														<div className="control is-expanded">
															<div className="select is-fullwidth">
																<Control
																	model=".comment"
																	component={RevisionComment}
																	modality={modality}
																	opts="project"
																	defaultValue={revision.registry.body && revision.registry.body.comment ? revision.registry.body.comment : 'Ninguno'}
																/>
															</div>
														</div>
														<div className="control">
															<div className="select">
																<Control model=".allow_edit" component={EditStatus} defaultValue={revision.registry.body && !_.isEmpty(revision.registry.body.allow_edit) ? revision.registry.body.allow_edit : 'false'} />
															</div>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table> :
									<p className="has-text-primary">
										<span className="icon has-text-danger">
											<i className="fa fa-lg fa-exclamation-triangle" />
										</span>
										Sin información <br /><br />
									</p>}


							</Fieldset>

							<fieldset className="fieldset">
								<legend>Metas del proyecto</legend>
								{registry.data && registry.data.project_goals && !_.isEmpty(registry.data.project_goals) ?
									<Fieldset component="table" model="registry.body.goals" className="table is-fullwidth project-goal-table">
										{_.map(_.sortBy(registry.data.project_goals, ['axis.name', 'code']), (goal, key) => {
											let muns = [];
											let goalRevision = revision.registry.body && revision.registry.body.goals ? _.find(revision.registry.body.goals, { id: goal.proigualdad_goal_id }) : null;
											!_.isEmpty(goal.agencies) ? _.map(goal.agencies, (mun) => muns.push(mun.agenciable.name)) : muns = null;
											return (
												<tbody key={key}>
													<tr>
														<td colSpan={4} className="goal-cell">
															<span className="help is-white">Eje temático</span>
															<strong>{goal && goal.axis ? goal.axis.name : '---'}</strong>
														</td>
													</tr>
													<tr>
														<td colSpan={4}>
															<span className="help is-dark">Línea de acción</span>
															<small>
																<strong>{goal && goal.line ? goal.line.name : '---'}</strong>
															</small>
														</td>
													</tr>
													<tr>
														<td rowSpan={3}>
															<span className="help is-inm-purple">Código</span>
															<strong className="has-text-inm-purple">{goal.code}</strong>
														</td>
														<td colSpan={2}>
															<span className="help is-dark">Meta</span>
															<strong>{goal.name}</strong>
														</td>
														<td className="has-text-right">
															<span className="help is-dark">Monto</span>
															<span>{formatMoney(goal.total)}</span>
														</td>
													</tr>
													<tr>
														<td colSpan={2}>
															<span className="help is-dark">Concepto de gasto</span>
															{goal.resource_concept_id && resource_concepts && !_.isEmpty(resource_concepts.list) ?
																<small>{_.find(resource_concepts.list, { id: goal.resource_concept_id }).name}</small> : ''}
														</td>
														<td colSpan={1} rowSpan={modality === 'modalidad-ii' ? 2 : 2} style={{ width: '190px' }}>
															{modality === 'modalidad-i' &&
																<div className="tags has-addons" style={{ cursor: 'pointer' }}>
																	<span className="tag is-light" onClick={() => this._openConagoModal(key, goal)}>Metas CONAGO</span>
																	<span
																		className="tag is-white">{_.size(goal.conago_clauses)}</span>
																</div>}

															<div className="tags has-addons" style={{ cursor: 'pointer' }}>
																<span className="tag is-light" onClick={() => this._openActorsModal(key, goal.actors)}>Actores estratégicos</span>
																<span className="tag is-white">{_.size(goal.actors)}</span>
															</div>
														</td>
													</tr>
													<tr>
														<td colSpan={2}>
															<span className="help is-dark">Documento meta</span>
															<small>{goal.goal_document}</small>
														</td>
													</tr>
													{modality !== 'modalidad-ii' ?
														<tr>
															<td colSpan={2}>
																<span className="help is-dark">Área geográfica</span>
																<small>{modality === 'modalidad-iii' ? 'Municipios' : goal.geographic_area ? goal.geographic_area : '---'}</small>
															</td>
															<td colSpan={2}>
																<span className="help is-dark">Municipios</span>
																{!_.isEmpty(muns) ?
																	<small>{_.join(muns, ', ')}</small> : '---'}
															</td>
														</tr> : null}
													<tr>
														<td colSpan={4}>
															<span className="help is-dark">Revisión de la meta</span>
															<div className="field has-addons">
																<div className="control">
																	<div className="select is-small">
																		<Control
																			model={`revision.registry.body.goals[${key}].status`}
																			component={NotificationStatus}
																			defaultValue={goalRevision && goalRevision.status ? goalRevision.status : 'success'}
																			changeAction={(model, value) => this._changeStatus(model, value, {
																				id: goal.proigualdad_goal_id,
																				model: `revision.registry.body.goals[${key}].id`
																			})} />
																	</div>
																</div>
																<div className="control is-expanded">
																	<div className="select is-small is-fullwidth">
																		<Control model={`revision.registry.body.goals[${key}].comment`} component={RevisionComment} modality={modality} opts="goals" defaultValue={goalRevision && goalRevision.comment ? goalRevision.comment : 'Ninguno'}
																		/>
																	</div>
																</div>
																<div className="control">
																	<div className="select is-small">
																		<Control model={`revision.registry.body.goals[${key}].allow_edit`} component={EditStatus} defaultValue={goalRevision && !_.isEmpty(goalRevision.allow_edit) ? goalRevision.allow_edit : 'false'} />
																	</div>
																</div>
															</div>
														</td>
													</tr>
													{!_.isEmpty(goal.project_goal_activities) ?
														<Fieldset model={`[${key}].activities`} component="tr">
															<td colSpan={4}>
																<table
																	className="table is-fullwidth project-activity-table">
																	<thead>
																		<tr>
																			<th>ID</th>
																			<th>Actividad</th>
																			<th>Cantidad</th>
																			<th>Monto</th>
																			<th>Medio de verificación</th>
																		</tr>
																	</thead>
																	<tbody>
																		{_.map(goal.project_goal_activities, (activity, j) => {
																			let activityRevision = goalRevision ? _.find(goalRevision.activities, { id: activity.proigualdad_activity_id }) : null;
																			return [
																				<tr key={j}>
																					<td>{activity.proigualdad_activity_id}</td>
																					<td>{activity.name}</td>
																					<td>{activity.quantity}</td>
																					<td>{formatMoney(activity.total)}</td>
																					<td>{activity.verification_media ? activity.verification_media.name : ''}</td>
																				</tr>,
																				<tr key={`rev-${j}`}>
																					<td colSpan={5}>
																						<span className="help is-dark">Revisión de la actividad {activity.proigualdad_activity_id}</span>
																						<div className="field has-addons">
																							<div className="control">
																								<div
																									className="select is-small">
																									<Control
																										model={`revision.registry.body.goals[${key}].activities[${j}].status`}
																										component={NotificationStatus}
																										defaultValue={activityRevision && activityRevision.status ? activityRevision.status : 'success'}
																										changeAction={(model, value) => {
																											this._changeStatus(model, value, {
																												id: activity.proigualdad_activity_id,
																												model: `revision.registry.body.goals[${key}].activities[${j}].id`
																											});
																											this.props.change(`revision.registry.body.goals[${key}].id`, goal.proigualdad_goal_id)
																										}} />
																								</div>
																							</div>
																							<div
																								className="control is-expanded">
																								<div
																									className="select is-small is-fullwidth">
																									<Control
																										model={`revision.registry.body.goals[${key}].activities[${j}].comment`}
																										component={RevisionComment}
																										modality={modality}
																										opts="activity"
																										defaultValue={activityRevision && activityRevision.comment ? activityRevision.comment : 'Ninguno'} />
																								</div>
																							</div>
																							<div className="control">
																								<div
																									className="select is-small">
																									<Control
																										model={`revision.registry.body.goals[${key}].activities[${j}].allow_edit`}
																										component={EditStatus}
																										defaultValue={activityRevision && !_.isEmpty(activityRevision.allow_edit) ? activityRevision.allow_edit : 'false'} />
																								</div>
																							</div>
																						</div>
																					</td>
																				</tr>
																			]
																		})}
																	</tbody>
																</table>
															</td>
														</Fieldset> : null}
												</tbody>
											)
										})}
									</Fieldset> :
									<p className="has-text-primary"><span className="icon has-text-danger"><i
										className="fa fa-lg fa-exclamation-triangle" /></span> Sin información <br /><br />
									</p>}
							</fieldset>

							<Fieldset model=".expenses.body" className="fieldset" component="fieldset">
								<legend>Gastos de coordinación</legend>
								{_.isEmpty(expenses.data) ?
									<p className="has-text-primary"><span className="icon has-text-danger"><i
										className="fa fa-lg fa-exclamation-triangle" /></span> Sin información <br /><br />
									</p> :
									<table className="is-fullwidth table">
										<tbody>
											{_.map(expenses.data.project_expenses, (exp, p) => {
												let expenseRevision = _.find(revision.expenses.body, { id: exp.id });
												expensesTotal += exp.total;
												return [
													<tr key={p}>
														<td>
															<span className="help is-dark">No.</span>
															<small>{p + 1}</small>
														</td>
														<td>
															<span className="help is-dark">Concepto</span>
															<small>
																<strong>{exp.expense_concept ? exp.expense_concept.name : '---'}</strong>
															</small>
														</td>
														<td>
															<span className="help is-dark">Unidad</span>
															<small>{exp.expense_unit ? exp.expense_unit.name : '---'}</small>
														</td>
														<td className="has-text-centered">
															<span className="help is-dark">Cantidad</span>
															<small>{exp.quantity}</small>
														</td>
														<td className="has-text-right">
															<span className="help is-dark">Valor unitario</span>
															<small>{formatMoney(exp.amount)}</small>
														</td>
														<td className="has-text-right">
															<span className="help is-dark">Total</span>
															<small><strong>{formatMoney(exp.total)}</strong></small>
														</td>
													</tr>,

													<tr key={`exp-rev-${p}`}>
														<td colSpan={6}>
															<span
																className="help is-dark">Revisión del gasto No. {p + 1}</span>
															<div className="field has-addons">
																<div className="control">
																	<div className="select is-small">
																		<Control model={`[${p}].status`}
																			defaultValue={expenseRevision && expenseRevision.status ? expenseRevision.status : 'success'}
																			component={NotificationStatus}
																			changeAction={(model, value) => this._changeStatus(model, value, {
																				id: exp.id,
																				model: `revision.expenses.body[${p}].id`
																			})} />
																	</div>
																</div>
																<div className="control">
																	<div className="select is-small is-fullwidth">
																		<Control model={`[${p}].comment`}
																			component={RevisionComment}
																			modality={modality} opts="expenses"
																			defaultValue={expenseRevision && expenseRevision.comment ? expenseRevision.comment : 'Ninguno'} />
																	</div>
																</div>
																<div className="control">
																	<div className="select is-small">
																		<Control model={`[${p}].allow_edit`}
																			component={EditStatus}
																			defaultValue={expenseRevision && !_.isEmpty(expenseRevision.allow_edit) ? expenseRevision.allow_edit : 'false'} />
																	</div>
																</div>
															</div>
														</td>
													</tr>
												]
											})}
											<tr>
												<td colSpan={6} className="goal-cell has-text-right has-text-white">
													<strong>{formatMoney(expensesTotal)}</strong></td>
											</tr>
										</tbody>
									</table>}
							</Fieldset>

							<Fieldset model=".profiles.body" component="fieldset" className="fieldset">
								<legend>Datos adicionales</legend>
								{profiles.data && !_.isEmpty(profiles.data.roles) ?
									<table className="is-fullwidth table">
										<tbody>
											<tr key={`profiles-info`}>
												<td>
													<span className="help is-dark">Perfiles adicionales requeridos</span>
													{_.isEmpty(profiles.data.roles) ? 'Ninguno' :
														<ul>
															{_.map(profiles.data.roles, (profile, j) => {
																let registred = _.find(employeesAgency, { role_id: profile.id });
																if (profile.agenciable_type === 'cdm' && modality === 'modalidad-iii') {
																	registred = _.find(employeesProject, {
																		role_id: profile.id,
																		project_goal_agency: { agency_id: profile.agency_id }
																	});
																}
																return <li key={j}
																	className={registred ? 'has-text-success' : 'has-text-danger'}>{profile.display}</li>
															})}
														</ul>
													}
												</td>
												<td>
													<span className="help is-dark">Perfiles capturados</span>
													<strong>{_.size(employeesAgency) + _.size(employeesProject)}</strong>
												</td>
												<td>
													<span className="help is-dark">Perfiles faltantes</span>
													<strong>{(_.size(profiles.data.roles) - (_.size(employeesAgency) + _.size(employeesProject)))}</strong>
												</td>
											</tr>
											<tr key={`profiles-fields`}>
												<td colSpan={3}>
													<span className="help is-dark">Revisión de datos adicionales</span>
													<div className="field has-addons">
														<div className="control">
															<div className="select">
																<Control model=".status" component={NotificationStatus}
																	defaultValue={revision.profiles.body && revision.profiles.body.status ? revision.profiles.body.status : 'success'} />
															</div>
														</div>
														<div className="control">
															<div className="select is-fullwidth">
																<Control model=".comment" component={RevisionComment}
																	modality={modality} opts="profiles"
																	defaultValue={revision.profiles.body && revision.profiles.body.comment ? revision.profiles.body.comment : 'Ninguno'} />
															</div>
														</div>
														<div className="control">
															<div className="select">
																<Control model=".allow_edit" component={EditStatus}
																	defaultValue={revision.profiles.body && !_.isEmpty(revision.profiles.body.allow_edit) ? revision.profiles.body.allow_edit : 'false'} />
															</div>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
									: <p className="has-text-primary"><span className="icon has-text-danger"><i
										className="fa fa-lg fa-exclamation-triangle" /></span> Sin información <br /><br />
									</p>}

							</Fieldset>

							<Fieldset model=".conclusion.body" component="fieldset" className="fieldset">
								<legend>Documentos</legend>
								{!_.isEmpty(conclusion.data) ?
									<table className="is-fullwidth table">
										<tbody>
											<tr>
												<td>
													<span className="help is-dark">Concluyó la captura de su proyecto</span>
													<strong
														className={conclusion.finished ? 'has-text-success' : 'has-text-danger'}>{conclusion.finished ? 'Concluida' : 'No concluida'}</strong>
												</td>
												<td>
													<div className="buttons">
														{_.map(conclusion.documents_items, (item, k) => {
															let document = conclusion.data.documents[item.slug]
															return (
																<a key={k} target="_blank" className="button is-primary is-small" href={document} disabled={document ? false : true}>
																	<span className="icon"><i
																		className="fa fa-link" /></span>
																	<span>{item.name}</span>
																</a>
															)
														})}
													</div>
												</td>
											</tr>
											<tr>
												<td colSpan={2}>
													<span className="help is-dark">Revisión de resumen de proyecto</span>
													<div className="field has-addons">
														<div className="control">
															<div className="select">
																<Control model=".document.status" component={NotificationStatus} defaultValue={revision.conclusion.body && revision.conclusion.body.document && revision.conclusion.body.document.status ? revision.conclusion.body.document.status : 'success'} />
															</div>
														</div>
														<div className="control">
															<div className="select is-fullwidth">
																<Control
																	model=".document.comment"
																	component={RevisionComment} modality={modality}
																	opts="conclusion"
																	defaultValue={revision.conclusion.body && revision.conclusion.body.document && revision.conclusion.body.document.comment ? revision.conclusion.body.document.comment : 'Ninguno'} />
															</div>
														</div>
														<div className="control">
															<div className="select">
																<Control
																	model=".document.allow_edit"
																	component={EditStatus}
																	defaultValue={revision.conclusion.body && revision.conclusion.body.document && !_.isEmpty(revision.conclusion.body.document.allow_edit) ? revision.conclusion.body.document.allow_edit : 'false'} />
															</div>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
									: <p className="has-text-primary"><span className="icon has-text-danger"><i
										className="fa fa-lg fa-exclamation-triangle" /></span> Sin información <br /><br />
									</p>}


								<h6 className="title is-6">COMENTARIOS ADICIONALES</h6>
								{revision.conclusion && !_.isEmpty(revision.conclusion.body) ?
									<table className="is-fullwidth table is-bordered">
										<tbody>
											<tr>
												<td>
													<span className="help is-dark">Comentarios y estatus general</span>
													<div className="field is-grouped">
														<div className="control is-expanded">
															<Control.textarea model=".comments" component={TextEditor} />
														</div>
														<div className="control">
															<div className="select">
																<Control
																	model=".status"
																	component={NotificationStatus}
																	defaultValue={revision.conclusion.body && revision.conclusion.body.status ? revision.conclusion.body.status : 'success'} />
															</div>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
									: <p className="has-text-primary"><span className="icon has-text-danger"><i
										className="fa fa-lg fa-exclamation-triangle" /></span> Sin información <br /><br />
									</p>}
							</Fieldset>

							{!_.isEmpty(revision.notifications_types) ?
								<fieldset className="fieldset">
									<legend>Notificación</legend>
									<table className="is-fullwidth table">
										<tbody>
											<tr>
												<td>
													<div className="field">
														<div className="control">
															<label htmlFor="" className="label">Tipo de notificación</label>
															<div className="select">
																<Control.select
																	model=".conclusion.notification_type_id"
																	id="status"
																	parser={toInt}
																	className="select"
																	validateOn="change">
																	<option value="" defaultValue>--- Tipo ---</option>
																	{_.map(revision.notifications_types, (opc, k) => {
																		return <option value={opc.id} key={k}>{opc.name}</option>
																	})}
																</Control.select>
															</div>
															{/*<Errors model=".conclusion.notification_type_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El tipo de notificación es obligatorio'}} />*/}
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</fieldset> : ''}

							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button type="button" className="button is-large" onClick={() => this.props.history.goBack()}>
										Regresar
									</button>
								</div>

								<div className="control">
									<Control.button model="revision" className="button is-large is-primary">Guardar Comentarios</Control.button>
								</div>
							</div>
						</Form>
					</div>

					{(!_.isEmpty(revision.commission.spvpu) && !_.isEmpty(revision.commission.answers)) &&
						<div className="column" style={{ display: revision.surveyShow ? 'block' : 'none' }}>
							<div style={{ position: 'fixed', height: '85%', top: '17%', overflowY: 'scroll' }}>
								{/*<h1 className="title is-6">ENCUESTA</h1>*/}
								<table className="table is-fullwidth project-goal-table no-margin">
									<tbody>
										<tr>
											<td className="goal-cell">
												<strong>Revisión de Proyecto</strong>
											</td>
										</tr>
										{(!_.isEmpty(revision.commission.spvpu) && !_.isEmpty(revision.commission.spvpu.survey_version_phase)) &&
											_.map(revision.commission.spvpu.survey_version_phase.survey.children_questions, (row, key) => {
												if (row.type === 'group') {
													return [
														<tr key={`group-${key}`}>
															<td>
																<strong>{(key + 1) + '. ' + row.name}</strong>
															</td>
														</tr>,
														_.map(row.children_questions, (item, k) => {
															return <RowQuestion
																key={k}
																number={key + 1}
																row={item}
																answer={_.find(revision.commission.answers, { question_id: item.id })}
															/>
														})
													]
												} else {
													return <RowQuestion
														key={key}
														number={key + 1}
														row={row}
														answer={_.find(revision.commission.answers, { question_id: row.id })}
													/>
												}
											})}
										<tr>
											<td className="goal-cell">
												<strong>Comentarios generales</strong>
											</td>
										</tr>
										<tr>
											<td>
												<small><span dangerouslySetInnerHTML={{ __html: revision.commission.comments ? revision.commission.comments : 'Ninguno' }}></span>
												</small>
											</td>
										</tr>
										<tr>
											<td className="goal-cell">
												<div className="level">
													<strong className="level-left">Puntuación total:</strong>
													<strong className="level-right">{this._totalScore()}</strong>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>}
				</div>
			</div>
		)
	}

	constructor(props) {
		super(props);
		this.state = {
			conagoShow: false,
			actorsShow: false,
			goalConago: [],
			goalActors: [],
			selectedGoal: undefined
		}
		this._toggleActorsModal = this._toggleActorsModal.bind(this);
		this._toggleConagoModal = this._toggleConagoModal.bind(this);
	}

	_toggleConagoModal() {
		return this.setState({ conagoShow: !this.state.conagoShow });
	}

	_toggleActorsModal() {
		return this.setState({ actorsShow: !this.state.actorsShow });
	}

	_openConagoModal(index, goal) {
		return this.setState({
			conagoShow: true,
			goalConago: goal.conago_clauses,
			selectedGoal: index
		})
	}

	_openActorsModal(index, actors) {
		return this.setState({
			actorsShow: true,
			goalActors: actors,
			selectedGoal: index
		})
	}

	_changeStatus(model, values, field) {
		this.props.change(model, values);
		this.props.change(field.model, field.id);
	}

	_handleSubmit(values) {
		let { modality, state, municipality } = this.props.match.params;
		this.props.saveProjectRevision(modality, state, municipality, values);
	}

	_totalScore() {
		let { commission } = this.props.revision;
		let total_score = commission && commission.answers ? _.sum(_.map(commission.answers, (row) => {
			if (row) {
				return row.answer_number;
			} else {
				return 0;
			}
		})) : 0;

		return total_score;
	}
}



// WEBPACK FOOTER //
// ./src/elements/revision/project.jsx